import { all } from 'typed-redux-saga'

import watchDocuments from './document/saga'

export default function* rootSaga() {
  return yield* all([watchDocuments()])
}
